// #region types
import { AuthEnums } from "models/enums";
import { IconDefinition } from "models/propTypes/iconPropTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { IconDefinitionConstants } from "utils/constants";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
// #endregion

function useBookingTreeService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getBookingTipSuggestions = (invoiceId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .IncomingInvoiceBookingTipClient.Get(invoiceId)
      .then((res) => res.data.items ?? []);
  };

  const getBookingTreeItems = (): Promise<WintSuperkollAPIModel.IncomingInvoiceBookingTreeItem[]> => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .IncomingInvoiceBookingTipClient.GetBookingTreeItems()
      .then((res) => res.data.items ?? []);
  };

  const convertToSelectionItems = (items: WintSuperkollAPIModel.IncomingInvoiceBookingTreeItem[]): SelectionItem[] => {
    return items.map((item) => ({
      id: item.account ? item.account : 0,
      value: item.name ?? "",
      description: item.path ? item.path.join(" / ") : "",
    }));
  };

  const convertToAutoCompleteItems = (
    items: WintSuperkollAPIModel.IncomingInvoiceBookingTreeItem[],
    group?: string
  ): AutocompleteListItem[] => {
    return items.map((item) => ({
      id: item.account ?? 0,
      value: item.name ?? "",
      description: item.path ? item.path.join(" / ") : "",
      group: group ?? "",
    }));
  };

  const getBookingTreeIcon = (accountNumber: number | undefined): IconDefinition => {
    switch (accountNumber) {
      case 1:
        return IconDefinitionConstants.WMoneyBag;
      case 3:
        return IconDefinitionConstants.WCalculator;
      case 4:
        return IconDefinitionConstants.WQuestionCircle;
      case 4010:
        return IconDefinitionConstants.WBuilding;
      default:
        return IconDefinitionConstants.WReceipt;
    }
  };

  return {
    getBookingTipSuggestions,
    getBookingTreeItems,
    convertToSelectionItems,
    convertToAutoCompleteItems,
    getBookingTreeIcon,
  };
}

export default useBookingTreeService;
